
import { supabase } from "@/integrations/supabase/client";
import { useQuery } from "@tanstack/react-query";
import { startOfDay, endOfDay } from "date-fns";

export const useTransactionData = (period: string, startDate?: Date) => {
  return useQuery({
    queryKey: ["transactions", period, startDate],
    queryFn: async () => {
      console.log("Filtering transactions for period:", period);

      // Utilisez la date actuelle pour aujourd'hui
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Début de la journée
      const endToday = endOfDay(today);

      console.log("Filtering for date range:", {
        start: today.toISOString(),
        end: endToday.toISOString()
      });

      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("Non authentifié");

      // Récupérer toutes les transactions pour aujourd'hui
      const { data: transactionsData, error } = await supabase
        .from("poultry_transactions")
        .select(`
          id,
          created_at,
          created_by,
          transaction_type,
          payment_method,
          total_amount,
          validation_status,
          transaction_date,
          notes,
          is_deducted_from_revenue,
          refund_amount,
          refund_payment_method,
          return_condition,
          stock_items (
            data
          )
        `)
        .eq('created_by', user.id)
        .gte('created_at', today.toISOString())
        .lte('created_at', endToday.toISOString())
        .not('validation_status', 'eq', 'validated')
        .in('transaction_type', ['sale', 'credit_payment', 'return'])
        .order('created_at', { ascending: false });

      if (error) {
        console.error("Error fetching transactions:", error);
        throw error;
      }

      console.log("Raw transactions found:", transactionsData);

      // Filtrer et traiter les transactions
      const processedTransactions = transactionsData?.map(tx => ({
        id: tx.id,
        transaction_type: tx.transaction_type,
        total_amount: tx.transaction_type === 'return' ? -tx.refund_amount : tx.total_amount || 0,
        payment_method: tx.payment_method || 'Espèces',
        refund_amount: tx.refund_amount,
        refund_payment_method: tx.refund_payment_method,
        return_condition: tx.return_condition,
        created_at: tx.created_at,
        notes: tx.notes,
        stock_items: tx.stock_items,
        transaction_date: tx.transaction_date || tx.created_at,
        is_deducted_from_revenue: tx.is_deducted_from_revenue || false
      })) || [];

      console.log("Processed transactions:", processedTransactions);

      return processedTransactions;
    },
    // Rafraîchir toutes les 30 secondes
    refetchInterval: 30000,
  });
};
